/**
 * Apelidos para os tipos que `esquema.ts` gera do OpenAPI da API.
 *
 * O arquivo gerado não é editado nem lido à mão: ele é retrato do contrato, e `npm run
 * api:tipos` o reescreve inteiro. Este aqui é a camada fina que dá nome ao que o cockpit
 * usa — se uma rota mudar de formato, o erro aparece na compilação e não na tela.
 */
import type { components } from "./esquema";

type Esquemas = components["schemas"];

export type Identidade = Esquemas["Identidade"];
export type RespostaDeSessao = Esquemas["RespostaDeSessao"];
export type RespostaPronto = Esquemas["RespostaPronto"];

export type ItemDaFila = Esquemas["ItemDaFila"];
export type DetalheDoTransito = Esquemas["DetalheDoTransito"];
export type Telemetria = Esquemas["Telemetria"];
/** Os seis cartões da régua da fila, contados no banco (`GET /transitos/resumo`). */
export type ResumoDaFila = Esquemas["ResumoDaFila"];
export type Status = Esquemas["Status"];
export type Enviado = Esquemas["Enviado"];
export type Consultado = Esquemas["Consultado"];
/** O regime de prazos de cada concessão (`GET /tollvision/regimes`, ADR-057). */
export type RegimeDaConcessaoNaTela = Esquemas["RegimeDaConcessaoNaTela"];
export type CenarioAtual = Esquemas["CenarioAtual"];
/** A contingência da SENATRAN (`R-06`, ADR-077): a faixa do topo e o *Tentar agora*. */
export type Contingencia = Esquemas["Contingencia"];
export type TentativaAgora = Esquemas["TentativaAgora"];
/** As notificações internas (`R-08`, ADR-078): a caixa da equipe e o que foi aos sistemas. */
export type NotificacoesInternas = Esquemas["NotificacoesInternas"];
export type NotificacaoInterna = Esquemas["NotificacaoInterna"];
export type FeitoNaNotificacao = Esquemas["Feito"];
export type ContagemDasNotificacoes = Esquemas["ContagemDasNotificacoes"];
export type DestinosDosSistemas = Esquemas["DestinosDosSistemas"];
export type DestinoDoSistema = Esquemas["DestinoDoSistema"];
export type DestinoGravado = Esquemas["DestinoGravado"];
/** O roteiro da demonstração: os dez cenários e quais aconteceram (`O-10`, ADR-064). */
export type RoteiroDaDemonstracao = Esquemas["RoteiroDaDemonstracao"];
export type CenarioNoRoteiro = Esquemas["CenarioNoRoteiro"];
// ------------------------------------------------- a lista de isentos (`A-06`, ADR-065)
export type ListaDeIsentos = Esquemas["ListaDeIsentos"];
export type LinhaDaLista = Esquemas["LinhaDaLista"];
export type ResultadoDaPlanilha = Esquemas["ResultadoDaPlanilha"];
export type IsencaoDoTransito = Esquemas["IsencaoDoTransito"];
export type OrigemDaIsencao = Esquemas["OrigemDaIsencao"];
export type EventoDaIntegracao = Esquemas["EventoDaIntegracao"];
// ------------------------------------------ cadastro da SENATRAN e carga histórica (ADR-035)
export type CadastroDaConcessao = Esquemas["CadastroDaConcessao"];
export type PorticoDoCadastro = Esquemas["PorticoDoCadastro"];
export type OperadorDoCadastro = Esquemas["OperadorDoCadastro"];
export type PreviaDaCarga = Esquemas["PreviaDaCarga"];

// ------------------------------------------------------------ validação do operador (0020)
export type SituacaoValidacao = Esquemas["SituacaoValidacao"];
export type AcaoDeValidacao = Esquemas["AcaoDeValidacao"];
export type PedidoValidacao = Esquemas["PedidoValidacao"];
export type ResultadoDaValidacao = Esquemas["ResultadoDaValidacao"];
export type DecisaoRegistrada = Esquemas["DecisaoRegistrada"];
// A fraude e a classe econômica (`OB-01`, ADR-066).
export type MotivoDeFraude = Esquemas["MotivoDeFraude"];
export type ClasseEconomica = Esquemas["ClasseEconomica"];
export type ClasseEconomicaDoPeriodo = Esquemas["ClasseEconomicaDoPeriodo"];
export type ParteDaClasse = Esquemas["ParteDaClasse"];
export type CompensacaoDaConcessao = Esquemas["CompensacaoDaConcessao"];
// O fechamento regulatório do período (`OB-06`, ADR-067).
export type OpcoesDoFechamento = Esquemas["OpcoesDoFechamento"];
export type PeriodoNaTela = Esquemas["PeriodoNaTela"];
export type ResumoDoFechamento = Esquemas["ResumoDoFechamento"];
export type LinhaDoResumo = Esquemas["LinhaDoResumo"];
export type FraudeNoFechamento = Esquemas["FraudeNoFechamento"];
// Os prazos e a receita em risco (`C-15`, ADR-068).
export type ReceitaEmRisco = Esquemas["ReceitaEmRisco"];
export type TrilhaDePrazoNaTela = Esquemas["TrilhaDePrazoNaTela"];
export type ContadorDePrazos = Esquemas["ContadorDePrazos"];
// A prova do protocolo de notificação (`OB-08`, ADR-071).
export type ProtocoloNaReceita = Esquemas["ProtocoloNaReceita"];
export type DossieDaPassagem = Esquemas["DossieDaPassagem"];
export type EtapaNoDossie = Esquemas["EtapaNoDossie"];
export type TentativaNoDossie = Esquemas["TentativaNoDossie"];
export type PlanilhaDeNotificacoes = Esquemas["PlanilhaDeNotificacoes"];
export type FilaDePrazos = Esquemas["FilaDePrazos"];
export type PrazoNaFila = Esquemas["PrazoNaFila"];
// Os índices regulatórios e a inoperância dos pórticos (`OB-05`, ADR-069).
export type IndicesRegulatorios = Esquemas["IndicesRegulatorios"];
export type IndiceNaTela = Esquemas["IndiceNaTela"];
export type ConcessaoNosIndices = Esquemas["ConcessaoNosIndices"];
export type PorticoNosIndices = Esquemas["PorticoNosIndices"];
export type InoperanciaNaTela = Esquemas["InoperanciaNaTela"];
export type OpcaoDosIndices = Esquemas["OpcaoDosIndices"];
export type NotaDoTransito = Esquemas["NotaDoTransito"];
/** O que o ciclo de vida do trânsito avisou, a quem e quando (`R-08`, `R-09`). */
export type NotificacaoDoTransito = Esquemas["NotificacaoDoTransito"];
export type NotaGravada = Esquemas["NotaGravada"];
export type ImagemDaAnalise = Esquemas["ImagemDaAnalise"];
export type SituacaoDasIas = Esquemas["SituacaoDasIas"];
export type SituacaoDaIa = Esquemas["SituacaoDaIa"];
export type FonteDeDados = Esquemas["FonteDeDados"];
export type AcertoDaIa = Esquemas["AcertoDaIa"];
export type PrazoAoVivo = Esquemas["PrazoAoVivo"];
export type ProximosPrazos = Esquemas["ProximosPrazos"];
export type PerdidosHoje = Esquemas["PerdidosHoje"];
// ------------------------------------------------------------ WhatsBI Cockpit (ADR-043)
export type RespostaDoAgente = Esquemas["RespostaDoAgente"];
export type FichaDoAgente = Esquemas["FichaDoAgente"];
export type GraficoDaFicha = NonNullable<FichaDoAgente["grafico"]>;
export type GraficoDeProjecaoDaFicha = Esquemas["GraficoDeProjecaoDaFicha"];
export type GraficoDeRankingDaFicha = Esquemas["GraficoDeRankingDaFicha"];
export type GraficoDeSerieDaFicha = Esquemas["GraficoDeSerieDaFicha"];
// A resposta como célula de notebook (`W-14`, ADR-049): as formas novas e a tabela.
export type GraficoDeColunasDaFicha = Esquemas["GraficoDeColunasDaFicha"];
export type GraficoDeLinhasDaFicha = Esquemas["GraficoDeLinhasDaFicha"];
export type GraficoDeMatrizDaFicha = Esquemas["GraficoDeMatrizDaFicha"];
export type TabelaDaFicha = Esquemas["TabelaDaFicha"];
export type ColunaDaTabela = Esquemas["ColunaDaTabela"];
// O histórico das conversas (`W-15`, ADR-050): as minhas e, no Admin, as da organização.
export type ConversaNaLista = Esquemas["ConversaNaLista"];
export type MinhasConversas = Esquemas["MinhasConversas"];
export type ConversaInteira = Esquemas["ConversaInteira"];
export type MensagemDaConversa = Esquemas["MensagemDaConversa"];
export type PessoaDaConversa = Esquemas["PessoaDaConversa"];
export type ConversaDaOrganizacao = Esquemas["ConversaDaOrganizacao"];
export type ConversasDaOrganizacao = Esquemas["ConversasDaOrganizacao"];
export type ConversaDaOrganizacaoInteira =
  Esquemas["ConversaDaOrganizacaoInteira"];
export type Sugestoes = Esquemas["Sugestoes"];
export type MeuWhatsApp = Esquemas["MeuWhatsApp"];
export type MeusAlertas = Esquemas["MeusAlertas"];
export type AlertaDaPessoa = Esquemas["AlertaDaPessoa"];
export type WhatsAppDaOrganizacao = Esquemas["WhatsAppDaOrganizacao"];
export type WhatsAppDaOrganizacaoNovo = Esquemas["WhatsAppDaOrganizacaoNovo"];
export type GuardaDasConversas = Esquemas["GuardaDasConversas"];
// O modelo de linguagem da organização e o consumo dele (ADR-044). Os valores em dólar
// chegam como texto (`Decimal` no servidor): a tela formata, não soma.
export type ModeloNaTela = Esquemas["ModeloNaTela"];
export type ModeloNovo = Esquemas["ModeloNovo"];
export type TesteDaChave = Esquemas["TesteDaChave"];
export type ConsumoDoModelo = Esquemas["ConsumoDoModelo"];
export type ChaveEmUso = ModeloNaTela["chave_em_uso"];
export type CelularAutorizado = Esquemas["CelularAutorizado"];
export type RegistroAdministrativo = Esquemas["RegistroAdministrativo"];
export type Limpeza = Esquemas["Limpeza"];
/** Uma régua qualquer: nome do cartão → contagem (`GET /tollvision/regua`). */
export type Regua = Record<string, number>;

/**
 * A validação como o operador a lê. Mesma regra do status: cor é significado (§1).
 * Aprovado é verde porque é o único que a SENATRAN aceita; revisão e backoffice são
 * atenção, porque esperam outra pessoa.
 */
export const APRESENTACAO_DA_VALIDACAO: Record<
  SituacaoValidacao,
  { rotulo: string; cor: "verde" | "amarelo" | "vermelho" | "azul" | "cinza" }
> = {
  // Amarelo, e não cinza (feedback de 21/09): pendente é "falta alguém olhar", e a fila
  // precisa separar isso do que já foi decidido num relance.
  PENDENTE: { rotulo: "Pendente", cor: "amarelo" },
  EM_REVISAO: { rotulo: "Em revisão", cor: "amarelo" },
  BACKOFFICE: { rotulo: "No backoffice", cor: "amarelo" },
  APROVADO: { rotulo: "Aprovado", cor: "verde" },
  // A supervisão confirmou que o usuário impediu a identificação (`OB-01`): não vai à
  // SENATRAN, e a passagem é inválida fraudulenta.
  FRAUDE: { rotulo: "Fraude confirmada", cor: "vermelho" },
};

/**
 * A classe econômica da passagem (`OB-01`, ADR-066), como a régua e o detalhe a dizem. Os
 * rótulos são os do contrato; "em apuração" é do cockpit — sem placa, e ainda dá tempo.
 */
export const APRESENTACAO_DA_CLASSE: Record<
  ClasseEconomica,
  { rotulo: string; cor: "verde" | "amarelo" | "vermelho" | "cinza" }
> = {
  VALIDA: { rotulo: "Válida", cor: "verde" },
  INVALIDA: { rotulo: "Inválida", cor: "cinza" },
  FRAUDULENTA: { rotulo: "Inválida fraudulenta", cor: "vermelho" },
  EM_APURACAO: { rotulo: "Em apuração", cor: "amarelo" },
};

/**
 * O id da imagem de análise por trás de um trânsito que nasceu de upload, ou `null`.
 *
 * Os módulos não se leem (regra de ouro nº 1 do `CLAUDE.md`), mas o **front** pode compor:
 * a referência externa `analise:<id>` é a ponte, e com ela a Operação mostra a foto e as
 * leituras que o módulo de Análise guardou — sem `JOIN` nenhum entre schemas.
 */
export function imagemDaAnalise(item: {
  referencia_externa: string;
}): string | null {
  // Só o formato de uma foto por trânsito (`analise:<id>`). Desde a 0022, as vistas do
  // mesmo veículo viram um trânsito com referência `analise:<lote>:<veículo>`, e as fotos
  // vêm em `imagens_de_analise` no detalhe.
  const resto = item.referencia_externa.startsWith("analise:")
    ? item.referencia_externa.slice("analise:".length)
    : null;
  return resto && !resto.includes(":") ? resto : null;
}

/** Nasceu de upload (uma foto ou um grupo de vistas)? */
export function veioDeUpload(item: { referencia_externa: string }): boolean {
  return item.referencia_externa.startsWith("analise:");
}

/** Como cada vista se chama na tela. Código de câmera fica como código. */
export function rotuloDaVista(vista: string): string {
  const nomes: Record<string, string> = {
    frente: "Frente",
    lateral: "Lateral",
    traseira: "Traseira",
    eixo: "Eixo",
    unica: "Imagem enviada",
  };
  if (nomes[vista]) return nomes[vista];
  if (vista.startsWith("camera-"))
    return `Câmera ${vista.slice(7).toUpperCase()}`;
  return vista.charAt(0).toUpperCase() + vista.slice(1).replaceAll("-", " ");
}

// ------------------------------------------------------------ régua gerencial (O-11/O-15)
export type Indicador = Esquemas["Indicador"];
export type ReguaGerencial = Esquemas["ReguaGerencial"];
export type OpcaoDeFiltro = Esquemas["OpcaoDeFiltro"];
export type PontoDaSerie = Esquemas["PontoDaSerie"];
export type Fatia = Esquemas["Fatia"];

/**
 * O filtro que as duas telas compartilham.
 *
 * Ele existe como tipo porque atravessa a fronteira entre as abas: a régua gerencial o
 * monta, a URL o carrega e a fila operacional o aplica. Um objeto solto em cada ponta é
 * como o drill-down passa a abrir uma fila que não é a que o número contou.
 */
export interface FiltroDoPeriodo {
  desde?: string;
  ate?: string;
  concessao_id?: string;
  praca_id?: string;
}

/** O mesmo filtro como query string — o formato que a API e a URL do cockpit aceitam. */
export function comoParametros(
  filtro: FiltroDoPeriodo,
  extras: Record<string, string> = {},
): string {
  const p = new URLSearchParams();
  for (const [chave, valor] of Object.entries({ ...filtro, ...extras })) {
    if (valor) p.set(chave, valor);
  }
  return p.toString();
}

// --------------------------------------------------------------- módulo Análise
export type ResumoDoLote = Esquemas["ResumoDoLote"];
export type ImagemDoLote = Esquemas["ImagemDoLote"];
export type ResultadoDaCapacidade = Esquemas["ResultadoDaCapacidade"];
export type ResultadoDeImagem = Esquemas["ResultadoDeImagem"];
export type ResultadoDoEnvio = Esquemas["ResultadoDoEnvio"];
export type ArquivoProcessado = Esquemas["ArquivoProcessado"];
export type CorrecaoFeita = Esquemas["CorrecaoFeita"];
export type NovaCorrecao = Esquemas["NovaCorrecao"];
export type CampoCorrigivel = NovaCorrecao["campo"];
export type Limites = { tipos_aceitos: string[]; tamanho_maximo_bytes: number };

/**
 * O portão de saída da `A-04`, com os **três** estados que ele tem — e nenhum dos três é
 * redundante.
 *
 * `null` é "ainda não tentamos": a imagem está na fila, e ninguém olhou para ela.
 * `false` é "tentamos e o serviço não garantiu": há motivo, e o operador pode reprocessar.
 * `true` é "há cópia anonimizada": o download abre.
 *
 * Colapsar os dois primeiros num "bloqueado" faria o operador reprocessar imagem que
 * ninguém tentou anonimizar ainda — gastando GPU e, pior, ensinando que o botão de
 * reprocessar é o que se aperta quando a tela não diz nada.
 */
export type EstadoDoPortao = "na-fila" | "travado" | "liberado";

export function portaoDaImagem(imagem: ImagemDoLote): EstadoDoPortao {
  if (imagem.anonimizacao === true) return "liberado";
  if (imagem.anonimizacao === null || imagem.anonimizacao === undefined)
    return "na-fila";
  return "travado";
}

// ------------------------------------------------------ administração do inquilino
export type UsuarioDaOrganizacao = Esquemas["UsuarioDaOrganizacao"];
/** As concessões da organização, para o recorte de cada usuário (`T-05`, `OB-13`). */
export type ConcessaoDaOrganizacao = Esquemas["ConcessaoDaOrganizacao"];
export type NovoUsuario = Esquemas["NovoUsuario"];
export type MudancaNoUsuario = Esquemas["MudancaNoUsuario"];
export type ChaveDoPortico = Esquemas["ChaveDoPortico"];
export type ChaveEmitida = Esquemas["ChaveEmitida"];
export type PainelDeLicencas = Esquemas["PainelDeLicencas"];
/** As cotas e os tetos do contrato (`B-03`, `A-09`, ADR-070) — `GET /admin/cotas`. */
export type TetosDoContrato = Esquemas["TetosDoContrato"];
export type CotaNaTela = Esquemas["CotaNaTela"];
export type Panorama = Esquemas["Panorama"];
export type ValorDaConfiguracao = Esquemas["ValorDaConfiguracao"];

/**
 * Como cada status se apresenta na tela: o rótulo em português e a cor que ele carrega.
 *
 * A cor não é escolha estética — é o §1 do design system. Verde é *dentro do prazo*, âmbar
 * é *atenção*, vermelho é *crítico*, cinza é *encerrado*. Um status novo no domínio quebra
 * a compilação aqui, que é o ponto: quem acrescenta estado precisa dizer o que ele
 * significa para quem olha a tela de longe.
 */
export const APRESENTACAO_DO_STATUS: Record<
  Status,
  { rotulo: string; cor: "verde" | "amarelo" | "vermelho" | "azul" | "cinza" }
> = {
  CAPTURADO: { rotulo: "Capturado", cor: "amarelo" },
  EM_PROCESSAMENTO: { rotulo: "Em processamento", cor: "amarelo" },
  ISENTO: { rotulo: "Isento", cor: "verde" },
  PAGO: { rotulo: "Pago", cor: "verde" },
  PENDENTE_PAGAMENTO: { rotulo: "Pendente de pagamento", cor: "azul" },
  CANCELADO: { rotulo: "Cancelado", cor: "vermelho" },
  NAO_ENVIAVEL: { rotulo: "Não enviável", cor: "vermelho" },
};

export type SituacaoDoEnvio = Esquemas["SituacaoDoEnvio"];
export type AcaoNecessaria = Esquemas["AcaoNecessaria"];

/**
 * A ação necessária de cada trânsito (o AC03 do cronograma). **Quem decide é o servidor**
 * (`transit_domain.senatran.acao_necessaria`); aqui fica só como ela aparece. As que pedem
 * alguém acendem; as de espera ficam neutras.
 */
export const APRESENTACAO_DA_ACAO: Record<
  AcaoNecessaria,
  { rotulo: string; cor: "verde" | "amarelo" | "vermelho" | "azul" | "cinza" }
> = {
  CONFERIR: { rotulo: "Conferir na Operação", cor: "amarelo" },
  ENVIAR: { rotulo: "Enviar à SENATRAN", cor: "amarelo" },
  REENVIAR: { rotulo: "Ver o motivo e reenviar", cor: "vermelho" },
  AGUARDAR_RETORNO: { rotulo: "Aguardar o retorno", cor: "cinza" },
  INFORMAR_DESFECHO: { rotulo: "Informar o desfecho", cor: "amarelo" },
  AGUARDAR_PAGAMENTO: { rotulo: "Aguardar o pagamento", cor: "cinza" },
  NENHUMA: { rotulo: "Nenhuma: encerrado", cor: "cinza" },
  AGUARDAR_A_SENATRAN: { rotulo: "Aguardar a SENATRAN voltar", cor: "cinza" },
};

/**
 * A coluna "Status SERPRO" (tarefa 9). **Quem decide a situação é o servidor**, pela regra
 * do domínio (`transit_domain.senatran.situacao_do_envio`); aqui fica só como ela aparece.
 * O `Record` obriga a ter uma entrada para cada valor que a API pode mandar.
 */
export const APRESENTACAO_DO_ENVIO: Record<
  SituacaoDoEnvio,
  { rotulo: string; cor: "verde" | "amarelo" | "vermelho" | "azul" | "cinza" }
> = {
  NAO_ENVIADO: { rotulo: "Não enviado", cor: "amarelo" },
  AGUARDANDO_RETORNO: { rotulo: "Aguardando retorno", cor: "azul" },
  EM_PROCESSAMENTO: { rotulo: "Em processamento", cor: "azul" },
  CANCELADO_PELO_PRAZO: {
    rotulo: "Cancelado (perdeu o prazo)",
    cor: "vermelho",
  },
  CANCELADO: { rotulo: "Cancelado", cor: "cinza" },
  REENVIADO: { rotulo: "Reenviado", cor: "verde" },
  ESTORNO_ERRO: { rotulo: "Estorno Erro", cor: "vermelho" },
  ACEITO: { rotulo: "Aceito", cor: "verde" },
  // A SENATRAN não respondeu (`R-06`): não é erro de ninguém, e o envio sai sozinho.
  NA_FILA: { rotulo: "Na fila da contingência", cor: "amarelo" },
};

/** `DEMO` não é trânsito de teste: é trânsito que não representa passagem nenhuma (`O-02`). */
export function ehDemonstracao(item: { origem: string }): boolean {
  return item.origem === "DEMO";
}

// ------------------------------------------------- o relógio da demonstração (O-03, ADR-059)
export type RelogioNaTela = Esquemas["RelogioNaTela"];

// ------------------------------------------------- o poder concedente (`PC-01`, ADR-072)
/** A tela Poder concedente (`GET /tollvision/poder-concedente`). */
export type PoderConcedenteNaTela = Esquemas["PoderConcedenteNaTela"];
export type ConcessaoNoPoderConcedente = Esquemas["ConcessaoNoPoderConcedente"];
export type PerfilNaTela = Esquemas["PerfilNaTela"];
export type EntregaNaTela = Esquemas["EntregaNaTela"];
export type GuardaNaTela = Esquemas["GuardaNaTela"];
export type OpcaoDePerfil = Esquemas["OpcaoDePerfil"];
export type NovoPerfil = Esquemas["NovoPerfil"];
// O calendário de entregas (`PC-02`, ADR-073).
export type CalendarioNaTela = Esquemas["CalendarioNaTela"];
export type ItemDoCalendarioNaTela = Esquemas["ItemDoCalendarioNaTela"];
export type RegistroNaTela = Esquemas["RegistroNaTela"];
export type DataDoContrato = Esquemas["DataDoContrato"];
export type EntregaSemData = Esquemas["EntregaSemData"];
export type NovaEntrega = Esquemas["NovaEntrega"];
export type Anulacao = Esquemas["Anulacao"];
// O canal de envio ao regulador (`PC-04`, ADR-074).
export type CanalNaTela = Esquemas["CanalNaTela"];
export type EnvioNaTela = Esquemas["EnvioNaTela"];
export type PreviaDoEnvio = Esquemas["PreviaDoEnvio"];
export type LinhaDaPrevia = Esquemas["LinhaDaPrevia"];
export type NovoEnvio = Esquemas["NovoEnvio"];
// O acesso do regulador (`PC-05`, `OB-13`, ADR-075): quem tem e o que viu.
export type AcessoDoRegulador = Esquemas["AcessoDoRegulador"];
export type ReguladorComAcesso = Esquemas["ReguladorComAcesso"];
export type DiaDeLeituras = Esquemas["DiaDeLeituras"];
// Os indicadores na gestão à vista (`PC-08`, ADR-076): os índices do mês com a tendência, e a
// falha crítica com o relógio do aviso (`GET /tollvision/poder-concedente/indices`).
export type IndicesNaGestao = Esquemas["IndicesNaGestao"];
export type ConcessaoNaGestao = Esquemas["ConcessaoNaGestao"];
export type IndiceNaGestao = Esquemas["IndiceNaGestao"];
export type PontoNaTela = Esquemas["PontoNaTela"];
export type FalhaNaGestao = Esquemas["FalhaNaGestao"];
export type AlertaNaTela = Esquemas["AlertaNaTela"];

// As tarifas do contrato de cada concessão (`SC-12`, ADR-084): a estrutura, que o perfil do
// poder concedente aponta, e o histórico do cadastro.
export type TarifasNaTela = Esquemas["TarifasNaTela"];
export type TarifasDaConcessao = Esquemas["TarifasDaConcessao"];
export type EstruturaNaTela = Esquemas["EstruturaNaTela"];
export type CategoriaDaEstrutura = Esquemas["CategoriaDaEstrutura"];
export type TrechoNaTela = Esquemas["TrechoNaTela"];
export type TarifaCadastrada = Esquemas["TarifaCadastrada"];
// A tabela nova (`OB-11`, ADR-086): a planilha com prévia, que entra inteira ou não entra.
export type TabelaNova = Esquemas["TabelaNova"];
export type ResultadoDaTabela = Esquemas["ResultadoDaTabela"];
export type ApontamentoNaTela = Esquemas["ApontamentoNaTela"];

// O menu pelo contrato (`T-21`, ADR-085) e a fila do autuador.
export type Navegacao = Esquemas["Navegacao"];
export type AreaNaNavegacao = Esquemas["AreaNaNavegacao"];
export type AutuacaoNaTela = Esquemas["AutuacaoNaTela"];
export type AutuacaoDaConcessao = Esquemas["AutuacaoDaConcessao"];
export type EvasaoNaFila = Esquemas["EvasaoNaFila"];

// A coleta dos pórticos (`SC-03`, ADR-087): recebe ou busca, e o último sinal do coletor.
export type ColetaDosPorticos = Esquemas["ColetaDosPorticos"];
export type ColetaNaTela = Esquemas["ColetaNaTela"];
export type NovaColeta = Esquemas["NovaColeta"];
export type ModoDeColeta = Esquemas["ModoDeColeta"];
export type SituacaoDaColeta = Esquemas["SituacaoDaColeta"];
// As passagens que faltam (`SC-04`, ADR-088): as lacunas da sequência de cada pórtico.
export type LacunasDoPortico = Esquemas["LacunasDoPortico"];
export type LacunaNaTela = Esquemas["LacunaNaTela"];
export type SituacaoDaLacuna = Esquemas["SituacaoDaLacuna"];
export type NoPortico = Esquemas["NoPortico"];

// A guarda das imagens (`SC-07`, ADR-089): a regra de cada concessão e as passadas do comando.
export type GuardaDasImagensNaTela = Esquemas["GuardaDasImagensNaTela"];
export type GuardaDaConcessao = Esquemas["GuardaDaConcessao"];
export type PassadaNaTela = Esquemas["PassadaNaTela"];

// O portal de pagamento (`PG-01`, ADR-081): a página do público e a configuração do administrador.
export type PortalPublico = Esquemas["PortalPublico"];
export type ResumoDaPlaca = Esquemas["ResumoDaPlaca"];
export type DetalheDaPlaca = Esquemas["DetalheDaPlaca"];
export type DebitoNoPortal = Esquemas["DebitoNoPortal"];
export type PortalDaConcessao = Esquemas["PortalDaConcessao"];
export type PortalNovo = Esquemas["PortalNovo"];
// Pagar no portal: o PIX (`PG-02`, ADR-090), o boleto e o cartão (`PG-03`, ADR-091).
export type CobrancaNoPortal = Esquemas["CobrancaNoPortal"];
export type MeioDePagamento = Esquemas["MeioDePagamento"];
// O comprovante em PDF e a segunda via (`PG-04`, ADR-092).
export type PagamentosDaPlaca = Esquemas["PagamentosDaPlaca"];
export type PagamentoDaPlaca = Esquemas["PagamentoDaPlaca"];
export type SituacaoDaCobranca = Esquemas["SituacaoDaCobranca"];
export type RecebedorNaTela = Esquemas["RecebedorNaTela"];
export type RecebedorNovo = Esquemas["RecebedorNovo"];
export type CobrancaNaTela = Esquemas["CobrancaNaTela"];
export type PagamentosDaConcessao = Esquemas["PagamentosDaConcessao"];
